import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Rocket, CheckCircle, Circle, X, Heartbeat, ListChecks, Wallet, BellRinging, Target, CheckSquare } from "@phosphor-icons/react";

const STEPS = [
  { id: "whoop", label: "Подключить Whoop", desc: "Вся аналитика здоровья", icon: Heartbeat, to: "/health" },
  { id: "habit", label: "Создать первую привычку", desc: "Трекер + влияние на восстановление", icon: CheckSquare, to: "/habits" },
  { id: "task", label: "Добавить задачу в планнер", desc: "Связь продуктивности и здоровья", icon: ListChecks, to: "/planner" },
  { id: "budget", label: "Записать первую операцию", desc: "Бюджет в рублях с лимитами", icon: Wallet, to: "/budget" },
  { id: "push", label: "Включить уведомления", desc: "Окно сна, красная зона, болезнь", icon: BellRinging, to: "/health" },
  { id: "goal", label: "Поставить цель месяца", desc: "Сон, восстановление, задачи", icon: Target, to: "/health" },
];

export default function QuickStartCard() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/onboarding/status").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || data.dismissed) return null;
  const done = STEPS.filter((s) => data.steps[s.id]).length;
  if (done === STEPS.length) return null;

  const dismiss = () => {
    setData((d) => ({ ...d, dismissed: true }));
    api.post("/onboarding/dismiss").catch(() => {});
  };

  return (
    <div className="glass-card border-primary/30 bg-gradient-to-br from-primary/10 to-transparent p-4 sm:p-6" data-testid="quickstart-card">
      <div className="flex items-center gap-2 mb-1">
        <Rocket size={20} weight="fill" className="text-primary" />
        <h3 className="font-heading font-semibold text-lg">Быстрый старт</h3>
        <span className="text-xs text-muted-foreground num ml-1" data-testid="quickstart-progress">{done} из {STEPS.length}</span>
        <button onClick={dismiss} data-testid="quickstart-dismiss-button"
          className="ml-auto p-1.5 rounded-md text-muted-foreground hover:text-foreground transition-colors"><X size={16} /></button>
      </div>
      <div className="h-1.5 rounded-full bg-secondary overflow-hidden mb-4">
        <div className="h-full rounded-full bg-primary transition-all" style={{ width: `${(done / STEPS.length) * 100}%` }} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {STEPS.map((s) => {
          const isDone = data.steps[s.id];
          const Icon = s.icon;
          return (
            <button key={s.id} onClick={() => !isDone && navigate(s.to)} data-testid={`quickstart-step-${s.id}`}
              className={`flex items-start gap-2.5 rounded-md border p-3 text-left transition-colors ${
                isDone ? "border-[#00e676]/30 bg-[#00e676]/5 cursor-default" : "border-border/40 bg-secondary/30 hover:bg-secondary/60"}`}>
              {isDone
                ? <CheckCircle size={18} weight="fill" className="text-[#00e676] shrink-0 mt-0.5" />
                : <Circle size={18} className="text-muted-foreground shrink-0 mt-0.5" />}
              <span className="min-w-0">
                <span className={`block text-xs font-semibold ${isDone ? "line-through text-muted-foreground" : ""}`}>
                  <Icon size={12} className="inline mr-1 -mt-0.5" />{s.label}
                </span>
                <span className="block text-[10px] text-muted-foreground mt-0.5">{s.desc}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
